import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl} from '@angular/forms';

@Component({
  selector: 'app-cross-company-report-dialog',
  templateUrl: './cross-company-report-dialog.component.html',
  styleUrls: ['./cross-company-report-dialog.component.scss']
})
export class CrossCompanyReportDialogComponent implements OnInit {
  monthControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<CrossCompanyReportDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.monthControl = fb.control('');
  }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.dialogRef.close(this.monthControl.value?.format('YYYY-MM'));
  }
}
